module.exports = __webpack_public_path__ + "components/flag/static/square/es-c7876fe988dbfb97b9f5d721cedd46f8.svg";